export default __webpack_public_path__ + "static/media/gallery_14.0d8df619.jpg";